var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sideMenu',{on:{"tabChange":_vm.tabChange}}),_c('Sidebar',{attrs:{"tab-index":_vm.tabIndex}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }